export default {
  GET_LIST: '/manage/userUpgradeRoleReqLog/findList',
  FIND: '/manage/userUpgradeRoleReqLog/find',
  DONE_OFF: '/manage/userUpgradeRoleReqLog/approve'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/upgradeRequest.js